// import { UilSignout } from '@iconscout/react-unicons';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { InfoWraper } from './auth-info-style';
import { startLogOut } from '../../../redux/authentication/actions';
import { switchRole } from '../../../redux/user/actions';
import { ReactComponent as LogoutIcon } from '../../../static/img/icon/logout.svg';
import LanguageDropdown from '../../Language-Dropdown/LanguageDropdown';
import { Button } from 'antd';
// import { Dropdown } from '../../dropdown/dropdown';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const hideSwitchBackToSuperadmin = location.pathname.includes('administrative_billing_details_submitted');
  const language = useSelector((state) => state?.auth?.language);
  const isLoggedIn = useSelector((state) => state?.auth?.login);
  const isSwitched = useSelector((state) => state?.user?.isSwitched);
  const currentRole = useSelector((state) => {
    const userRole = state?.auth?.user?.role;
    const meUserRole = state?.auth?.me?.user?.roles?.[0];
    const meRootRole = state?.auth?.me?.roles?.[0];
    return userRole || meUserRole || meRootRole;
  });
  const me = useSelector((state) => state?.auth?.me);

  const isMerchant = useSelector((state) => {
    const userRole = state?.auth?.user?.role;
    const meUserRole = state?.auth?.me?.user?.roles?.[0];
    const meRootRole = state?.auth?.me?.roles?.[0];
    const role = userRole || meUserRole || meRootRole;
    return role === 'merchant';
  });

  const prevIsSwitchedRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn || typeof isSwitched !== 'boolean') return;

    const prev = prevIsSwitchedRef.current;
    prevIsSwitchedRef.current = isSwitched;

    // Only redirect on role-switch transitions — not while superadmin is already unswitched,
    // otherwise any effect re-run (e.g. after getMe) forces /merchants and blocks navigation.
    if (isSwitched === true && currentRole === 'merchant' && prev !== true) {
      navigate('/profile', { replace: true });
      return;
    }
    if (isSwitched === false && currentRole === 'super_admin' && prev === true) {
      navigate('/merchants', { replace: true });
      return;
    }
    if (isSwitched === false && currentRole === 'staff' && prev === true) {
      navigate('/staff-profile', { replace: true });
      return;
    }
    if (isSwitched === false && currentRole === 'sales_agent' && prev === true) {
      navigate('/sales-agent-profile', { replace: true });
    }
  }, [isLoggedIn, isSwitched, currentRole, navigate]);

  const SignOut = (e) => {
    e.preventDefault();
    dispatch(startLogOut());
  };

  const switchBackToAdmin = () => {
    dispatch(switchRole({ switch_back: true }));
  };
  return (
    <InfoWraper>
      <div className="ninjadash-nav-actions__item ninjadash-nav-actions__author d-flex align-items-center">
        <div>
          <LanguageDropdown />
        </div>
        {/* {isLoggedIn && isMerchant && isSwitched === true && !hideSwitchBackToSuperadmin && (
          <button
            type="button"
            className="ml-2 ant-btn ant-btn-default"
            style={{ marginLeft: '16px' }}
            onClick={switchBackToAdmin}
          >
            {language?.content?.SWITCH_BACK_TO_SUPERADMIN || 'Switch back to Superadmin'}
          </button>
        )} */}
        {isLoggedIn && (
          <Link className="user-dropdwon__bottomAction ml-2" style={{ marginLeft: '26px' }} onClick={SignOut} to="#">
            <LogoutIcon />
          </Link>
        )}
      </div>
    </InfoWraper>
  );
});

export default AuthInfo;
